import React, { useEffect } from "react";
import logo from "../../../assets/images/logo.png";
import HeaderLink from "../HeaderLink";
import { Link } from "react-router-dom";
import HeaderSocial from "../HeaderSocial";
import EmailIcon from "../../../assets/icons/EmailIcon";
import PhoneIcon from "../../../assets/icons/PhoneIcon";
import MenuIcon from "../../../assets/icons/MenuIcon";
import { useSelector } from "react-redux";
import ChangeLang from "../ChangeLang";
import v_logo from "../../../assets/images/v.png"
function Header() {
  const contactData = useSelector(state => state.Data.contactData);
  const langPrefix = useSelector(state => state.Data.langPrefix);
  useEffect(()=>{
    window.addEventListener("scroll", (e)=>{
      const header = document.querySelector("header");
      if(window.scrollY>=150){
        if(header){
          header.style.position = "fixed";
          header.style.top = "0";
        }
      }else{
        if(header){
          header.style.position = "relative";
          header.style.top = "0px";
        }
      }
    })
  },[])
  const onCloseNav = () => {
    const btn = document.querySelector("#navBtn");
    if(btn){
      btn.checked = false
    }
  }
  return (
    <div className="relative z-[1000]">
      {/* <HeaderSocial /> */}
      <input type="checkbox" id="navBtn" className="hidden" />
      <div onClick={()=>onCloseNav()} className="fixed top-0 left-0 w-full h-screen bg-black/20 hidden navBgShadow z-1"></div>
      <header className="h-[100px] flex items-center shadow shadow-b w-full top-[50px] left-0 z-2 bg-white ">
        <div className="flex flex-1 bg-white h-full"></div>
        <div className=" w-full container3 bg-white h-full">
          <div className="flex items-center bg-[--red] h-full gap-[30px] max-[1100px]:justify-between max-[1240px]:gap-[10px]">
          
          <div className="flex items-center  h-full max-w-[300px]">
            <Link to={`/${langPrefix}`} className="relative z-[1] bg-white inline-flex items-center h-full px-[10px] ml-[-2px]">
              <img src={logo} alt="logo" className="h-[74px] w-[170px] min-w-[170px] max-[1240px]:w-[150px] max-[1240px]:h-[65px]" />
            </Link>
            <div className="nav_clip h-full w-[140px] bg-white ml-[-42px] mr-[-70px]"></div>
           </div>
            <div className="resp-nav   flex items-center justify-between max-[1240px]:gap-[10px] flex-1">
              <HeaderLink />
              <a href="https://stage.voltmills.az/" target="_blank" className="inline-flex justify-center items-center p-[10px] h-[60px] w-[190px] bg-yellow-300 rounded-[8px] max-[1240px]:h-[80px] max-[1240px]:w-[160px] border border-white">
                <img src={v_logo} />
              </a>
              <ChangeLang />
              <div className="flex items-start justify-center flex-col ">
                <a href={`mailto:${contactData?.email}`} className="flex items-center gap-[7px]">
                  <span className="inline-flex w-[35px] h-[35px] justify-center items-center rounded-full ">
                    <EmailIcon />
                  </span>
                  <span className="font-[600] text-[16px] max-[1240px]:text-[13px] text-white">{contactData?.email}</span>
                </a>
                <a href={`tel:${contactData?.phone_1}`} className="flex items-center gap-[7px]">
                  <span className="inline-flex w-[35px] h-[35px] justify-center items-center rounded-full ">
                    <PhoneIcon color="#fff" />
                  </span>
                  <span className="font-[600] text-[16px] max-[1240px]:text-[13px] text-white">{contactData?.phone_1}</span>
                </a>
              </div>
            </div>
            <label htmlFor="navBtn" className="hidden max-[1100px]:inline-block mr-[20px]">
              <MenuIcon />
            </label>
          </div>
        </div>
        <div className="flex flex-1 bg-[--red] h-full ml-[-1px] min-w-[20px]"></div>
      </header>
    
    </div>
    // <div className="relative z-[1000]">
    //     <div className="bg-white h-[100px] flex items-center">
    //       <div className="flex flex-1 bg-white h-full"></div>
    //       <div className="w-[1500px] bg-[--red] h-full">
          //  <div className="flex items-center  h-full max-w-[300px]">
          //   <Link to={`/${langPrefix}`} className="relative z-[1] bg-white inline-flex items-center h-full px-[10px] ml-[-2px]">
          //     <img src={logo} alt="logo" className="h-[74px] w-[170px] min-w-[170px] max-[1240px]:w-[150px] max-[1240px]:h-[65px]" />
          //   </Link>
          //   <div className="nav_clip h-full w-[140px] bg-white ml-[-0px]"></div>
          //  </div>
    //       </div>
    //       <div className="w-full flex flex-1 h-full bg-[--red]"></div>
    //     </div>
    // </div>
   
  );
}

export default Header;
